<template>
  <div class="root-container-stm">
    <div :key="$i18n.locale">
      <template v-if="$route.meta.newLayout">
        <TheLayout />
      </template>
      <router-view v-else></router-view>
    </div>
    <dialogs-wrapper></dialogs-wrapper>
  </div>
</template>

<script>
import TheLayout from './components/TheLayout.vue'

export default {
  name: 'App',

  components: {
    TheLayout,
  },
}
</script>
